import {
  columnSettings,
  defaultColumns
} from '@/angularBridgeCode/services/BuyerServiceV2';

export default {
  widget: {
    iconClass: 'typcn typcn-eject-outline',
    title: ''
  },
  buyers: [],
  buyerReferences: {},
  checkReferencesText: '',
  columnSettings: columnSettings,
  userVisibleColumns: defaultColumns,
  currentAccountFeatureFlags: {},
  status: {},
  invitesForBuyer: {},
  showNewBuyerInvites: false
};
